import { filterDOMProps, mergeProps } from '@react-aria/utils';
import { useButton, useFocusRing, useHover } from 'react-aria';
import { ButtonContext, useContextProps } from 'react-aria-components';
import { additionalForwardableProps } from '../../utils/additionalForwardableProps.js';
export function useReactAriaButton({ ref, props, }) {
    // eslint-disable-next-line no-param-reassign
    [props, ref] = useContextProps(props, 
    // cast is required since ButtonContext from react-aria-components always expects an HTMLButtonElement
    ref, ButtonContext);
    const { isDisabled } = props;
    const { buttonProps, isPressed } = useButton(props, ref);
    const { focusProps, isFocused, isFocusVisible } = useFocusRing(props);
    const { hoverProps, isHovered } = useHover(props);
    return {
        ref,
        buttonProps: {
            children: props.children,
            ...filterDOMProps(props, { propNames: additionalForwardableProps, isLink: props.elementType === 'a' }),
            ...mergeProps(buttonProps, focusProps, hoverProps),
            'data-rac': true,
            'data-disabled': isDisabled || undefined,
            'data-pressed': isPressed || undefined,
            'data-hovered': isHovered || undefined,
            'data-focused': isFocused || undefined,
            'data-focus-visible': isFocusVisible || undefined,
        },
        isDisabled,
        isPressed,
        isFocused,
        isFocusVisible,
        isHovered,
    };
}
//# sourceMappingURL=useReactAriaButton.js.map